
import { get, post, put, del } from './api';

export const getCategories = async () => {
  const res = await get('/categories');
  return res.data;
};

export const addCategorie = async (data) => {
  await post('/categories', data);
};

export const updateCategorie = async (id, data) => {
  await put(`/categories/${id}`, data);
};

export const deleteCategorie = async (id) => {
  await del(`/categories/${id}`);
};

export const getTitresByCategorie = async (categorieId) => {
  const res = await get(`/titres?categorie=${categorieId}`);
  return res.data;
};

export const addTitre = async (data) => {
  await post('/titres', data);
};

export const deleteTitre = async (id) => {
  await del(`/titres/${id}`);
};

export const getProduitsParCategorie = async (id) => {
  const res = await get(`/produits/stats/produits-par-categorie/${id}`);
  return res.data;
};

export const getProduitsParTitre = async (id) => {
  const res = await get(`/produits/stats/produits-par-titre/${id}`);
  return res.data;
};

export const addCategorieWithImage = async (categorie, image) => {
  const formData = new FormData();
  formData.append('categorie', categorie);
  if (image) formData.append('image', image);

  const res = await post('/categories', formData);
  return res.data;
};

export const getCategoriesWithImages = async () => {
  const res = await get('/categories');
  return res.data;
};
// services/produitsPublics.js
// import { get } from './api';

export const getProduitsByCategorieId = async (id) => {
  const res = await get(`/produits/categorie/${id}/produits`);
  return res.data;
};
